var _circle, _path, _path2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearLaboratoryCoat50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19,14l1-1l-2-1l0.927-1.854c-1.553,0.335-2.922,1.266-3.795,2.646L9.42,21.816l3.38,2.139L17,17.32 V38h6V18L19,14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.868,12.79c-0.873-1.379-2.241-2.31-3.795-2.645L30,12l-2,1l1,1l-4,4v20h6V17.319l4.2,6.636 l3.38-2.139L32.868,12.79z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "21,10 24,17 27,10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearLaboratoryCoat50);
export default __webpack_public_path__ + "static/media/icons8-wear-laboratory-coat-50.7036cc00044725ba063f9318fdd2ddeb.svg";
export { ForwardRef as ReactComponent };